import { Avatar, For, HStack, Box, Flex, Card, Heading, Stack, Strong, Text, Button, Separator, ToggleTip } from "@chakra-ui/react"
import { LuAArrowUp, LuArrowBigLeft } from "react-icons/lu"
import { IoIosArrowForward } from "react-icons/io";
import ProfileService from "@/services/profile"
import _ from "lodash"
import { useEffect, useState } from "react";
import { formatCurrency } from "@/utilities/number"
import { useAuth } from "contexts/auth";
import { useNavigate } from "react-router";
import { useStore } from "contexts/store";
import { useApp } from "contexts/app";
import { useChat } from "contexts/chat";
import  MenuItem  from "components/menu-item"
import DebtService from "services/debt"
const service = new ProfileService();
const debtService = new DebtService();

const Profile = () => {

    const [profile, setProfile] = useState({})
    const [debtSummary, setDebtSummary] = useState({})
    const { showLoading, setPageTitle } = useApp();
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const { openChat, hasChatEntry } = useChat();

    const { store } = useStore();
    useEffect(() => {
        setPageTitle("Tài khoản")
    }, [setPageTitle])

    useEffect(() => {

        load();
    }, [])




    const quotes = [
        {
            "id": 1,
            "text": "Mỗi khách hàng là một món quà – dù đôi khi món quà đó cần... hướng dẫn sử dụng! 🎁"
        },
        {
            "id": 2,
            "text": "Đường đến thành công đầy thử thách – nhưng ít ra không kẹt xe như đường đến công ty! 🚗💨"
        },
        {
            "id": 3,
            "text": "Cười lên nào, vì lợi nhuận chưa đến… nhưng tinh thần thì phải có trước! 😄"
        },

        {
            "id": 5,
            "text": "Thị trường là một cuộc chơi – ai kiên trì cười nhiều hơn sẽ thắng! 🎯"
        },
        {
            "id": 8,
            "text": "Bán hàng là nghệ thuật, còn chốt đơn là… siêu năng lực! 🦸"
        },

    ];

    const load = async () => {
        const [profileData, debtData] = await Promise.all([
            service.get(),
            debtService.getSummary().catch(() => ({})),
        ]);
        setProfile(profileData || {});
        setDebtSummary(debtData || {});
    }

    return (

        <>

            <Stack>

                <Card.Root size="sm">
                    <Card.Body>
                        <HStack mb="6" gap="3">
                            <Avatar.Root size={"2xl"}>
                                <Avatar.Image src={profile.info?.avatar?.url} />
                                <Avatar.Fallback name={profile.info?.full_name} />
                            </Avatar.Root>
                            <Stack gap="0">
                                <Text fontWeight="semibold" textStyle="sm">
                                    {profile.info?.full_name}
                                </Text>
                                <Text color="fg.muted" textStyle="sm">
                                    {profile.info?.phone}
                                </Text>
                            </Stack>
                        </HStack>
                        <Card.Description>

                            {_.shuffle(quotes)[0].text}
                        </Card.Description>
                    </Card.Body>

                </Card.Root>
                <Card.Root size="sm">
                    <Card.Header>
                        <Heading size="md"> Đơn hàng</Heading>
                    </Card.Header>
                    <Card.Body color="fg.muted">
                        <Stack>
                            <MenuItem label="Cần thanh toán" extra={profile.order?.payment_pending} onClick={e => navigate("/order-list?status=payment_pending")}></MenuItem>
                            <MenuItem label="Đang vận chuyển" extra={profile.order?.shipping} onClick={e => navigate("/order-list?status=shipping")} ></MenuItem>
                            <MenuItem label="Đã hoàn tất" extra={profile.order?.finalized} onClick={e => navigate("/order-list?status=finalized")}></MenuItem>
                            <MenuItem label="Tất cả" extra={profile.order?.all} onClick={e => navigate("/order-list?status=all")}></MenuItem>
                        </Stack>
                    </Card.Body>
                </Card.Root>

                <Card.Root size="md">
                    <Card.Header>
                        <Heading size="md">Xu và Voucher</Heading>
                    </Card.Header>
                    <Card.Body color="fg.muted">
                        <Stack>
                            <MenuItem label="Xu" extra={formatCurrency(profile.point?.current)} onClick={e => navigate("/point")} ></MenuItem>
                            {/* <MenuItem label="Voucher"  extra={profile.voucher?.available}></MenuItem> */}
                            {/* <MenuItem label="Hướng dẫn đổi voucher" extra={""}></MenuItem> */}
                        </Stack>
                    </Card.Body>
                </Card.Root>

                <Card.Root size="md">
                    <Card.Header>
                        <Heading size="md">Công nợ</Heading>
                    </Card.Header>
                    <Card.Body color="fg.muted">
                        <Stack>
                            <MenuItem label="Số dư hiện tại" extra={formatCurrency(debtSummary?.current_debt ?? 0)} onClick={e => navigate("/debt")} ></MenuItem>
               
                        </Stack>
                    </Card.Body>
                </Card.Root>

                {store.collaborator?.collaborator &&


                    <Card.Root size="md">
                        <Card.Header>
                            <Heading size="md">Tiếp thị liên kết</Heading>
                        </Card.Header>
                        <Card.Body color="fg.muted">
                            <Stack>
                                <MenuItem label="💰 Chia sẻ link - Nhận hoa hồng. Bán hàng mà không cần nhập hàng." extra={""} onClick={e => navigate("/ctv")} ></MenuItem>
                                <MenuItem label="Lịch sử hoa hồng" extra={""} onClick={e => navigate("/ctv/history")} ></MenuItem>
                                <MenuItem label="Thiết lập tài khoản nhận hoa hồng" extra={""} onClick={e => navigate("/profile/bank")} ></MenuItem>
                                {/* <MenuItem label="Voucher"  extra={profile.voucher?.available}></MenuItem> */}
                                {/* <MenuItem label="Hướng dẫn đổi voucher" extra={""}></MenuItem> */}
                            </Stack>
                        </Card.Body>
                    </Card.Root>
                }

                <Card.Root size="lg">
                    {/* <Card.Header>
                        <Heading size="md"> Cài đặt</Heading>
                    </Card.Header> */}
                    <Card.Body color="fg.muted">
                        <Stack>
                            <MenuItem label="Cập nhật thông tin" onClick={e => navigate("/profile/edit")}></MenuItem>

                            {hasChatEntry &&
                                <MenuItem label="Hỗ trợ khách hàng" onClick={e => openChat()}></MenuItem>
                            }
                            <MenuItem label="Đăng Xuất" extra={""} onClick={logout}></MenuItem>
                        </Stack>
                    </Card.Body>
                </Card.Root>
            </Stack>

        </>





    )
}


export default Profile